import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { isObject } from '../isObject';
import { ErrorResponse } from './ErrorResponse';
export class PayoutErrorResponse {
    authorizationError() {
        var _this_authorizationErrorByCode_code;
        if (this.error.status !== 403) return null;
        const body = this.error.body;
        const code = isObject(body) && typeof body.code === 'string' ? body.code : null;
        return code != null ? (_this_authorizationErrorByCode_code = this.authorizationErrorByCode[code]) !== null && _this_authorizationErrorByCode_code !== void 0 ? _this_authorizationErrorByCode_code : null : null;
    }
    constructor(error){
        _define_property(this, "error", void 0);
        _define_property(this, "authorizationErrorByCode", {
            role_claim_missing: 'roleClaimMissing',
            insufficient_role: 'insufficientRole'
        });
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
    }
}
